"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseDate = void 0;
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var ChooseDate = function (props) {
    var getMonth = function (d) {
        return props.utc ? d.getUTCMonth() : d.getMonth();
    };
    var setMonth = function (d, value) {
        if (props.utc) {
            d.setUTCMonth(value);
        }
        else {
            d.setMonth(value);
        }
    };
    var getDate = function (d) {
        return props.utc ? d.getUTCDate() : d.getDate();
    };
    var setDate = function (d, value) {
        if (props.utc) {
            d.setUTCDate(value);
        }
        else {
            d.setDate(value);
        }
    };
    var getFullYear = function (d) {
        return props.utc ? d.getUTCFullYear() : d.getFullYear();
    };
    var setFullYear = function (d, value) {
        if (props.utc) {
            d.setUTCFullYear(value);
        }
        else {
            d.setFullYear(value);
        }
    };
    var compareDates = function (d1, d2) {
        if ((getMonth(d1) === getMonth(d2)) && (getDate(d1) === getDate(d2)) && (getFullYear(d1) === getFullYear(d2))) {
            return 0;
        }
        return (d1.valueOf() - d2.valueOf());
    };
    var initDate = function (d) {
        var newDate = props.date ? props.date
            : new Date(getFullYear(new Date()), getMonth(new Date()), (props.monthOnly ? 1 : getDate(new Date())));
        if (props.minDate && compareDates(newDate, props.minDate) < 0) {
            newDate = props.minDate;
            if (props.monthOnly && (getDate(props.minDate) !== 1)) {
                setDate(newDate, 1);
                setMonth(newDate, getMonth(newDate) + 1);
            }
            props.onChange(newDate);
        }
        if (props.maxDate && compareDates(newDate, props.maxDate) > 0) {
            newDate = props.maxDate;
            if (props.monthOnly && (getDate(props.maxDate) !== 1)) {
                setDate(newDate, 1);
                setMonth(newDate, getMonth(newDate) + 1);
            }
            props.onChange(newDate);
        }
        return newDate;
    };
    var _a = react_1.default.useState(initDate(props.date)), date = _a[0], setDateValue = _a[1];
    react_1.default.useEffect(function () {
        setDateValue(initDate(props.date));
    }, [props.date]);
    var daysInMonth = function (month, yr) {
        var period = ([8, 3, 5, 10].indexOf(month) > -1) ? 30 : 31;
        if (month === 1) {
            period = props.noYear ? 28
                : (yr % 400 === 0) ? 29
                    : ((yr % 100 === 0) ? 28
                        : ((yr % 4 === 0) ? 29 : 28));
        }
        return period;
    };
    var onDateChanged = function (e) {
        var newDate = new Date(date);
        var endDay;
        if (e.target.name === "month") {
            endDay = daysInMonth(e.target.value, getFullYear(date));
            if (getDate(date) > endDay) {
                setDate(newDate, endDay);
            }
            setMonth(newDate, e.target.value);
            if (props.minDate && compareDates(newDate, props.minDate) < 0) {
                setFullYear(newDate, getFullYear(props.minDate) + 1);
            }
            else if (props.maxDate && compareDates(newDate, props.maxDate) > 0) {
                setFullYear(newDate, getFullYear(props.maxDate) - 1);
            }
        }
        else if (e.target.name === "day") {
            setDate(newDate, e.target.value);
            if (props.minDate && compareDates(newDate, props.minDate) < 0) {
                setMonth(newDate, getMonth(props.minDate) + 1);
            }
            else if (props.maxDate && compareDates(newDate, props.maxDate) > 0) {
                setMonth(newDate, getMonth(props.maxDate) - 1);
            }
        }
        else {
            endDay = daysInMonth(getMonth(date), e.target.value);
            if (getDate(date) > endDay) {
                setDate(newDate, endDay);
            }
            setFullYear(newDate, e.target.value);
            if (props.minDate && compareDates(newDate, props.minDate) < 0) {
                setMonth(newDate, 11);
                setDate(newDate, props.monthOnly ? 1 : 31);
            }
            else if (props.maxDate && compareDates(newDate, props.maxDate) > 0) {
                setMonth(newDate, 0);
                setDate(newDate, 1);
            }
        }
        setDateValue(newDate);
        props.onChange(newDate);
    };
    var years = [];
    var year = getFullYear(new Date());
    var i;
    for (i = year - (props.yearMin || 0); i < year + (props.yearMax || 0); i++) {
        years.push(i);
    }
    if (years.indexOf(getFullYear(date)) === -1) {
        years.push(getFullYear(date));
        years.sort();
    }
    var title;
    if (props.title) {
        title = (react_1.default.createElement(Grid_1.default, { item: true, style: { width: props.titleWidth } },
            react_1.default.createElement("h4", { style: { marginBottom: 0 } }, props.title)));
    }
    var days = [];
    var lastDay = daysInMonth(getMonth(date), getFullYear(date));
    for (i = 1; i <= lastDay; i++) {
        days.push(i);
    }
    return (react_1.default.createElement(Grid_1.default, { container: true, direction: "row", justify: "flex-start", alignItems: "center" },
        title,
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(FormControl_1.default, { margin: "dense" },
                        props.noLabels ? null : strings_1.default.chooseDate.month,
                        react_1.default.createElement(InputLabel_1.default, { id: "select-month" }),
                        react_1.default.createElement(Select_1.default, { style: { width: 150 }, labelId: "month", id: "month", name: "month", variant: "outlined", key: "month", disabled: props.readOnly, value: getMonth(date), onChange: onDateChanged }, strings_1.default.chooseDate.months.map(function (m, idx) {
                            return (react_1.default.createElement(MenuItem_1.default, { key: m, value: idx }, m));
                        })))),
                props.monthOnly ? null
                    : react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(FormControl_1.default, { margin: "dense" },
                            props.noLabels ? null : strings_1.default.chooseDate.day,
                            react_1.default.createElement(InputLabel_1.default, { id: "select-day" }),
                            react_1.default.createElement(Select_1.default, { style: { width: 100 }, labelId: "day", id: "day", name: "day", variant: "outlined", key: "day", disabled: props.readOnly, value: getDate(date), onChange: onDateChanged }, days.map(function (d) {
                                return (react_1.default.createElement(MenuItem_1.default, { key: d, value: d }, d));
                            })))),
                props.noYear ? null
                    : react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(FormControl_1.default, { margin: "dense" },
                            props.noLabels ? null : strings_1.default.chooseDate.year,
                            react_1.default.createElement(InputLabel_1.default, { id: "select-year" }),
                            react_1.default.createElement(Select_1.default, { style: { width: 100 }, labelId: "year", id: "year", name: "year", key: "year", variant: "outlined", disabled: props.readOnly, value: getFullYear(date), onChange: onDateChanged }, years.map(function (y) {
                                return (react_1.default.createElement(MenuItem_1.default, { key: y, value: y }, y));
                            }))))))));
};
exports.ChooseDate = ChooseDate;
exports.ChooseDate.defaultProps = {
    utc: true,
};
